export default "__VITE_ASSET__69c588aa__$_?component__"